module.exports = __webpack_public_path__ + "img/weixin1.5a26b77a.png";